import { wrapCreateBrowserRouterV7 } from '@sentry/react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router';

import { env } from '@/config/env';
import {
  HandleWithCrumb,
  InstanceCrumb,
} from '@/features/editor/components/tree/breadcrumbs';
import { useAppDispatch } from '@/stores/store';
import { CallbackAuth, NotFoundPage } from '@nablax/shared/pages';
import { toggleTheme } from '@nablax/shared/stores';
import { memo, useEffect } from 'react';

const sentryCreateBrowserRouter = env.VITE_SENTRY_ENABLED
  ? wrapCreateBrowserRouterV7(createBrowserRouter)
  : createBrowserRouter;

export const ROUTER = sentryCreateBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      lazy={() => import('./layouts/common.layout')}
      HydrateFallback={() => null}
    >
      <Route path="/airfoil" lazy={() => import('./routes/foil-redirect')} />
      <Route
        path="editor/:projectId"
        lazy={() => import('./layouts/editor.layout')}
      >
        <Route index lazy={() => import('./routes/editor-redirect')} />
        <Route lazy={() => import('./layouts/editor-main.layout')}>
          <Route index element={null} />
          <Route path="components">
            <Route
              path=":geometryClass"
              lazy={() => import('./routes/geometry-class')}
            >
              <Route
                path=":geometryBaseName"
                lazy={() => import('./routes/geometry-instance')}
                handle={{ crumb: InstanceCrumb } as HandleWithCrumb}
              />
            </Route>
          </Route>
        </Route>
      </Route>
      <Route path="/callback" Component={CallbackAuth} />
      <Route path="*" Component={NotFoundPage} />
    </Route>,
  ),
  { basename: `/${env.VITE_BUILD_BASE_PATH}` },
);

export const AppRouter = memo(() => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(toggleTheme({ preload: true }));
  }, []);

  return <RouterProvider router={ROUTER}></RouterProvider>;
});
AppRouter.displayName = 'AppRouter';
